class ChangeViewsNumber {
    constructor() {
        this.btns = document.querySelectorAll(".our-audience__btn");
        this.viewsNumber = document.querySelector(".our-audience__number");
        this.events();
    }

    events() {
        this.btns.forEach((el) => {
            el.addEventListener("click", (e) => {
                this.deleteClass();
                e.currentTarget.classList.add("selected");
                this.setNumber(e.currentTarget);
            });
        });
    }

    setNumber(evt){
        let valueOfViews = evt.dataset.views;
        this.viewsNumber.innerText = valueOfViews
    }

    deleteClass() {
        this.btns.forEach((e) => {
            if (e.classList.contains("selected")) {
                e.classList.remove("selected");
            }
        });
    }
}

export default ChangeViewsNumber;
